export default {
  data() {
    return {
      selectedChildItems: [],
      choicesPrice: 0,
    }
  },
  methods: {
    selectChoice(modifier, choice, preSelectQty, isChildPreSelected) {
      // find if choice is already selected with item_id and item_config_id
      let selectedChoice = this.selectedChildItems.find(
        (item) =>
          item.item_id === choice.itemid &&
          item.pick_list_id === modifier.pick_list_id &&
          (!choice.item_config_id || item.item_config_id === choice.item_config_id)
      )
      if (selectedChoice) {
        // if selected, remove it from selectedChildItems by filtering it out by item_id pick_list_id and if choice has item_config_id by item_config_id
        this.selectedChildItems = this.selectedChildItems.filter(
          (item) =>
            item.item_id !== choice.itemid ||
            item.pick_list_id !== modifier.pick_list_id ||
            (choice.item_config_id && item.item_config_id !== choice.item_config_id)
        )
      } else {
        // check if modifier is min 1 and max 1 or min 0 and max 1
        if ((modifier.mincount == 1 && modifier.maxcount == 1) || (modifier.mincount == 0 && modifier.maxcount == 1)) {
          // check if there is a choice already selected from the same modifier
          let selectedChoices = this.selectedChildItems.filter((item) => item.pick_list_id === modifier.pick_list_id)
          if (selectedChoices.length > 0) {
            // if there is a choice already selected, remove it from selectedChildItems
            this.selectedChildItems = this.selectedChildItems.filter(
              (item) => item.pick_list_id !== modifier.pick_list_id
            )
          }
        }
        if (!this.checkMinMax(modifier)) {
          let toasterData = {
            show: true,
            message: "You can't select more than " + modifier.maxcount + ' choices for ' + "'" + modifier.prompt + "'",
          }
          this.SET_TOASTER(toasterData)
          return
        }
        // find the variant with style_name Whole
        let wholeVariant = null
        if (choice.variants) {
          wholeVariant = choice.variants.find((variant) => variant.style_name === 'Whole')
        }
        let choiceData = {
          menu_id: choice.menuid,
          price: wholeVariant ? wholeVariant.price : choice.baseprice,
          name: choice.itemname,
          quantity: preSelectQty ? preSelectQty : 1,
          pick_list_id: modifier.pick_list_id,
          item_id: choice.itemid,
          item_config_id: choice.item_config_id,
          category_id: choice.catid,
          style_id: wholeVariant ? wholeVariant.item_style_id : choice.item_style_id,
          size_id: choice.item_size_id,
          display_style: modifier.display_style,
          free_up_to: modifier.free_up_to,
        }
        if (choice.variants) {
          choiceData.size_id = choice.variants[0].item_size_id
        }
        if (isChildPreSelected) {
          return choiceData
        }
        if (!this.checkIfPriceIsVisible(modifier, choice)) {
          choiceData.price = 0
        }
        this.selectedChildItems.push(choiceData)
      }
      this.calculateChoicesPrice()
    },
    checkIfSelected(modifier, choice) {
      let selectedChoice = this.selectedChildItems.find(
        (item) =>
          item.item_id === choice.itemid &&
          item.pick_list_id === modifier.pick_list_id &&
          (!choice.item_config_id || item.item_config_id === choice.item_config_id)
      )
      if (selectedChoice) {
        if (choice.item_style_id) {
          return selectedChoice.style_id === choice.item_style_id
        }
        return true
      }
      return false
    },
    checkIfShouldScrollToNext(modifier) {
      if (modifier.maxcount !== 0 && this.getQtyOfModifier(modifier) >= modifier.maxcount) {
        const modifierIndex = this.getModifiers.findIndex((mod) => mod.pick_list_id === modifier.pick_list_id);
        const nextModifier = document.querySelectorAll('.modifier')[modifierIndex + 1];
        if (nextModifier) {
          nextModifier.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },   
    getQtyOfModifier(modifier) {
      let selectedChoices = this.selectedChildItems.filter((item) => item.pick_list_id === modifier.pick_list_id)
      let totalQty = 0
      selectedChoices.forEach((choice) => {
        totalQty += choice.quantity
      })
      return totalQty
    },
    checkMinMax(modifier) {
      let selectedChoices = this.selectedChildItems.filter((item) => item.pick_list_id === modifier.pick_list_id)
      // get the total quantity of selected choices
      let totalQuantity = 0
      selectedChoices.forEach((choice) => {
        totalQuantity += choice.quantity
      })
      if (totalQuantity + 1 < modifier.mincount) {
        return true
      } else if (totalQuantity + 1 > modifier.maxcount) {
        return false
      } else {
        return true
      }
    },
    getSelectedCount(itemId) {
      let count = 0
      this.selectedChildItems.forEach((item) => {
        if (item.item_id === itemId) {
          if (item.child_items && item.child_items.length > 0) {
            count = item.child_items.length
          }
        }
      })
      return count
    },
    getSelectedChildItemNames(itemId) {
      let names = []
      this.selectedChildItems.forEach((item) => {
        if (item.item_id === itemId) {
          if (item.child_items && item.child_items.length > 0) {
            item.child_items.forEach((childItem) => {
              if (childItem.display_style != 'hidden') {
                names.push(childItem.name)
              }
            })
          }
        }
      })
      return names.join(', ')
    },
    getMinMax(modifier) {
      let minMax
      if (modifier.mincount == 0 && modifier.maxcount == 99) {
        minMax = ''
        return minMax
      } else if (modifier.mincount == 0 && modifier.maxcount != 0) {
        minMax = 'SELECT UP TO ' + modifier.maxcount
      } else if (modifier.mincount == modifier.maxcount) {
        minMax = 'SELECT ' + modifier.mincount
        return minMax
      } else if (modifier.mincount != 0 && modifier.maxcount == 99) {
        minMax = 'SELECT AT LEAST ' + modifier.mincount
      } else if (modifier.mincount != 0 && modifier.maxcount != 0) {
        minMax = 'SELECT ' + modifier.mincount + ' TO ' + modifier.maxcount
        return minMax
      }
      return minMax
    },
    getPizzaSidePrice(choice) {
      // find the price of choice in selectedChildItems
      let selectedChoice = this.selectedChildItems.find((item) => item.item_id === choice.itemid)
      if (selectedChoice) {
        return this.formatPrice(selectedChoice.price)
      }
    },
    getAllergyIcons(icons) {
      if (icons) {
        // get all allergens and join them with comma and space
        let allergens = this.storeConfig.allergens.filter((allergen) => icons.includes(allergen.id))
        let allergenNames = allergens.map((allergen) => allergen.name)
        if (allergenNames.length > 0) {
          return allergenNames.join(', ')
        }
        return false
      }
    },
    checkIfSideSelected(choice, sideName) {
      let selectedChoice = this.selectedChildItems.find((item) => item.item_id === choice.itemid)
      if (selectedChoice && choice.variants?.length > 2) {
        let sideStyle = choice.variants.find((variant) => variant.style_name === sideName)
        if (sideStyle && sideStyle.item_style_id) {
          if (selectedChoice.style_id === sideStyle.item_style_id) {
            return true
          } else {
            return false
          }
        }
      }
    },
    selectSide(choice, sideName) {
      let selectedChoice = this.selectedChildItems.find((item) => item.item_id === choice.itemid)
      let sideStyle = choice.variants.find((variant) => variant.style_name === sideName)
      selectedChoice.style_id = sideStyle.item_style_id
      selectedChoice.price = sideStyle.price
      this.calculateChoicesPrice()
    },
    calculateChoicesPrice() {
      let price = 0
      let itemCount = []
      let itemCount1 = 0
      let itemCount2 = 0

      this.selectedChildItems.forEach((item) => {
        if (itemCount[item.pick_list_id] == undefined || itemCount[item.pick_list_id] == null) {
          itemCount[item.pick_list_id] = 0
        }
        itemCount[item.pick_list_id]++
        if (item.free_up_to < itemCount[item.pick_list_id]) {
          price += item.price * item.quantity
        }
        if (item.child_items) {
          itemCount1 = 0
          item.child_items.forEach((childItem) => {
            itemCount1++
            if (
              childItem.free_up_to == null ||
              childItem.free_up_to == undefined ||
              childItem.free_up_to < itemCount1
            ) {
              price += childItem.price * item.quantity
            }
            if (childItem.child_items) {
              itemCount2 = 0
              childItem.child_items.forEach((childItem) => {
                itemCount2++
                if (
                  childItem.free_up_to == null ||
                  childItem.free_up_to == undefined ||
                  childItem.free_up_to < itemCount2
                ) {
                  price += childItem.price * item.quantity
                }
              })
            }
          })
        }
      })
      this.choicesPrice = price
    },
    checkExpandedChoices(choice) {
      // check if choice is expanded
      let expanded = this.openNutritionChoicesIds.find((item) => item.id === choice.itemid)
      if (expanded) {
        return true
      }
      return false
    },
    expandNutritionInfo(choice) {
      // check if choice is already expanded
      let expanded = this.openNutritionChoicesIds.find((item) => item.id === choice.itemid)
      if (expanded) {
        // remove from array
        this.openNutritionChoicesIds = this.openNutritionChoicesIds.filter((item) => item.id !== choice.itemid)
      } else {
        // add to array
        this.openNutritionChoicesIds.push({ id: choice.itemid })
      }
    },
    getMultiChoiceQuantity(choice) {
      let selectedChoice = this.selectedChildItems.find((item) => item.item_id === choice.itemid)
      if (selectedChoice) {
        return selectedChoice.quantity
      }
    },
    changeChoiceQty(type, choice, modifier) {
      let originalChoiceQty = this.getMultiChoiceQuantity(choice)
      let selectedChoice = this.selectedChildItems.find((item) => item.item_id === choice.itemid)
      if (type === 'minus') {
        if (selectedChoice.quantity > 1) {
          selectedChoice.quantity = selectedChoice.quantity - 1
        }
      } else if (type === 'plus') {
        if (selectedChoice.quantity == 99) {
          return
        }
        if (!this.checkMinMax(modifier)) {
          let toasterData = {
            show: true,
            message: "You can't select more than " + modifier.maxcount + ' choices for ' + "'" + modifier.prompt + "'",
          }
          this.SET_TOASTER(toasterData)
          return
        }
        selectedChoice.quantity = selectedChoice.quantity + 1
      }
      // check if selectedChoice has child items
      if (selectedChoice.child_items) {
        // multiply the quantity of each child item by selectedChoice quantity
        selectedChoice.child_items.forEach((childItem) => {
          let qtyForOne = childItem.quantity / originalChoiceQty
          childItem.quantity = qtyForOne * selectedChoice.quantity
        })
      }
      this.checkIfShouldScrollToNext(modifier)
      this.calculateChoicesPrice()
    },
    checkRequiredSelections(modifiers) {
      let requiredSelectionsComplete = true
      for (let [index, modifier] of modifiers.entries()) {
        // check if modifier is required
        if (modifier.mincount != 0) {
          // get selected choices of the modifier
          let selectedChoices = this.selectedChildItems.filter((item) => item.pick_list_id === modifier.pick_list_id)
          // add all of the quantities of selected choices
          let selectedChoicesQuantity = selectedChoices.reduce((a, b) => a + b.quantity, 0)
          // check if selected choices are less than mincount
          if (selectedChoicesQuantity < modifier.mincount) {
            // show toaster
            let toasterData = {
              show: true,
              message: 'You must select at least ' + modifier.mincount + ' choices for ' + "'" + modifier.prompt + "'",
            }
            this.SET_TOASTER(toasterData)
            // shake modifier
            let modifierElement = document.getElementsByClassName('modifier')[index]
            modifierElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            })
            modifierElement.classList.add('shake')
            // check if modifier is already in expandedModifiers
            let expanded = this.expandedModifiers.find((item) => item.pick_list_id === modifier.pick_list_id)
            if (!expanded) {
              this.expandedModifiers.push({ pick_list_id: modifier.pick_list_id })
            }
            setTimeout(() => {
              modifierElement.classList.remove('shake')
            }, 1500)
            requiredSelectionsComplete = false
            break
          }
        }
      }
      return requiredSelectionsComplete
    },
    checkIfHasRequiredNestedModifiers(modifier, choice) {
      let hasRequiredNestedModifiers = false
      // check if choice has child items
      if (choice.child_pick_list_data && this.checkIfSelected(modifier, choice)) {
        // go through each modifier
        choice.child_pick_list_data.pick_lists.forEach((modifier) => {
          // check if modifier is required
          if (modifier.mincount != 0) {
            // get the index of the choice in selectedChildItems
            let selectedChoiceIndex = this.selectedChildItems.findIndex((item) => item.item_id === choice.itemid)
            // get selected choices of the modifier
            if (!this.selectedChildItems[selectedChoiceIndex].child_items) {
              hasRequiredNestedModifiers = true
            } else {
              let selectedChoices = this.selectedChildItems[selectedChoiceIndex].child_items.filter(
                (item) => item.pick_list_id === modifier.pick_list_id
              )
              // check if selected choices are less than mincount
              if (selectedChoices.length < modifier.mincount) {
                hasRequiredNestedModifiers = true
              }
            }
          }
          modifier.pick_list_items.forEach((subChoice) => {
            // find the index of the parent choice in selectedChildItems
            let parentChoiceIndex = this.selectedChildItems.findIndex((item) => item.item_id === choice.itemid)
            // check if choice has child items
            if (subChoice.child_pick_list_data) {
              // go through each modifier
              subChoice.child_pick_list_data.pick_lists.forEach((subModifier) => {
                // check if modifier is required and selected
                if (
                  subModifier.mincount != 0 &&
                  this.checkIfNestedSelected(subModifier, subChoice, parentChoiceIndex)
                ) {
                  if (parentChoiceIndex >= 0 && this.selectedChildItems[parentChoiceIndex].child_items) {
                    // find subChoice index in selectedChildItems
                    let subChoiceIndex = this.selectedChildItems[parentChoiceIndex].child_items.findIndex(
                      (item) => item.item_id === subChoice.itemid
                    )
                    if (subChoiceIndex) {
                      if (!this.selectedChildItems[parentChoiceIndex].child_items[subChoiceIndex].child_items) {
                        hasRequiredNestedModifiers = true
                      } else {
                        // get selected choices of the modifier
                        let selectedChoices = this.selectedChildItems[parentChoiceIndex].child_items[
                          subChoiceIndex
                        ].child_items.filter((item) => item.pick_list_id === subModifier.pick_list_id)
                        // check if selected choices are less than mincount
                        if (selectedChoices.length < subModifier.mincount) {
                          hasRequiredNestedModifiers = true
                        } else {
                          hasRequiredNestedModifiers = false
                        }
                      }
                    }
                  }
                }
              })
            }
          })
        })
      }
      return hasRequiredNestedModifiers
    },
    checkIfNestedSelected(modifier, choice, parentChoiceIndex) {
      let selectedChoice = this.selectedChildItems[parentChoiceIndex].child_items?.find(
        (item) => item.item_id === choice.itemid
      )
      if (selectedChoice) {
        return true
      }
    },
    checkIfPriceIsVisible(modifier, choice) {
      // check if defaults are free
      if (modifier.defaults_are_free) {
        // check if choice has price and choice is default (preselected)
        if (choice.baseprice != 0 && choice.default_qty > 0) {
          return false
        }
        // check if choice has price and choice is not default (preselected)
        else if (choice.baseprice != 0 && choice.default_qty == 0) {
          return true
        } else {
          return false
        }
      }

      if (choice.baseprice != 0) {
        return true
      } else {
        return false
      }
    },
    getPreSelectedChoices(modifiers) {
      modifiers.forEach((modifier) => {
        // go through each choice
        modifier.pick_list_items.forEach((choice) => {
          let parentChoiceIndex
          // check if choice is preselected
          if (choice.default_qty != 0) {
            // add it to selectedChildItems
            this.selectChoice(modifier, choice, choice.default_qty, null, 'modal')
            // if modifier has preselected choices add it to expandedModifiers
            this.expandedModifiers.push({ pick_list_id: modifier.pick_list_id })
          }
          // if choice has child items go through each child item
          if (choice.child_pick_list_data && choice.default_qty != 0) {
            choice.child_pick_list_data.pick_lists.forEach((modifier) => {
              // go through each choice
              modifier.pick_list_items.forEach((subChoice) => {
                // check if choice is preselected
                if (subChoice.default_qty != 0) {
                  // get choice data
                  let choiceData = this.selectChoice(modifier, subChoice, choice.default_qty, true, 'modal')
                  // find the index of parent choice in selectedChildItems
                  parentChoiceIndex = this.selectedChildItems.findIndex(
                    (item) =>
                      item.item_id === choice.itemid &&
                      (!choice.item_config_id || item.item_config_id === choice.item_config_id)
                  )
                  // if child_items array doesn't exist create it and add choiceData to it
                  if (parentChoiceIndex != -1) {
                    if (!this.selectedChildItems[parentChoiceIndex].child_items) {
                      this.selectedChildItems[parentChoiceIndex].child_items = []
                      this.selectedChildItems[parentChoiceIndex].child_items.push(choiceData)
                    } else {
                      // if child_items array exists add choiceData to it
                      this.selectedChildItems[parentChoiceIndex].child_items.push(choiceData)
                    }
                  }
                }
                // if choice has child items go through each child item
                if (subChoice.child_pick_list_data) {
                  subChoice.child_pick_list_data.pick_lists.forEach((modifier) => {
                    // go through each choice
                    modifier.pick_list_items.forEach((subSubChoice) => {
                      // check if choice is preselected
                      if (subSubChoice.default_qty != 0) {
                        // get choice data
                        let choiceData = this.selectChoice(modifier, subSubChoice, choice.default_qty, true, 'modal')
                        // find the index of parent choice in selectedChildItems[parentChoiceIndex].child_items
                        let subParentChoiceIndex = this.selectedChildItems[parentChoiceIndex].child_items.findIndex(
                          (item) => item.item_id === subChoice.itemid
                        )
                        // if child_items array doesn't exist create it and add choiceData to it
                        if (subParentChoiceIndex != -1) {
                          if (
                            !this.selectedChildItems[parentChoiceIndex].child_items[subParentChoiceIndex].child_items
                          ) {
                            this.selectedChildItems[parentChoiceIndex].child_items[subParentChoiceIndex].child_items =
                              []
                            this.selectedChildItems[parentChoiceIndex].child_items[
                              subParentChoiceIndex
                            ].child_items.push(choiceData)
                          } else {
                            // if child_items array exists add choiceData to it
                            this.selectedChildItems[parentChoiceIndex].child_items[
                              subParentChoiceIndex
                            ].child_items.push(choiceData)
                          }
                        }
                      }
                    })
                  })
                }
              })
            })
          }
        })
      })
    },
  },
}
